import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '../../../../../components/Button';
import SubHeader from '../../../../../components/SubHeader';
import {
  nextStep,
  selectType,
  changeStep,
} from '../../../../../redux/new-schedule';

class ScheduleTypeChoice extends Component {
  componentDidMount = () => {
    if (this.props.currentStep !== 1) { this.props.dispatch(changeStep(this.props.currentStep)); }
  };

  render() {
    const { history, match } = this.props;
    return (
      <div>
        <SubHeader title="Agendar" renderSide={() => {}} />
        <div className="NewSchedule__schedule-type-container">
          <h1 className="NewSchedule__title">1. Tipo de agendamento</h1>
          <p className="NewSchedule__text">
            Selecione o tipo de agendamento que deseja realizar:
          </p>
          <div className="NewSchedule__button-wrapper">
            <Button
              className="NewSchedule__button"
              large
              text="Carga"
              onClick={() => {
                history.push(`${match.url}/carga`);
                this.props.dispatch(selectType(0));
                this.props.dispatch(nextStep(2));
              }}
            />
            <Button
              className="NewSchedule__button"
              large
              text="Descarga"
              onClick={() => {
                history.push(`${match.url}/descarga`);
                this.props.dispatch(selectType(1));
                this.props.dispatch(nextStep(2));
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentStep: state.newSchedule.currentStep,
});

export default connect(mapStateToProps)(ScheduleTypeChoice);
